import {
  DesignProp,
  LayoutProp,
} from "@circle-react-shared/BuilderUI/constants/PropCategories";

export const columnGap = {
  prop: "style-attribute",
  name: "Column gap",
  nameI18n: "builder_ui.prop_type.styles.column_gap",
  category: [DesignProp, LayoutProp],
  type: "slider",
  sliderProps: {
    min: 0,
    max: 320,
    step: 1,
    units: ["px", "rem", "%"],
    defaultUnit: "px",
  },
} as const;
